/* Book Arena: butoanele duc la formular, bara de jos apare dupa prima sectiune si dispare cand formularul e pe ecran. */
(function () {
  function init() {
    var form = document.getElementById('comanda');
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ba-go]');
      if (!a || !form) return;
      e.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    pages();
    /* Formularul Releasit lasa cateva cuvinte in engleza pe care aplicatia nu le poate traduce: le inlocuim aici. */
    if (form && 'MutationObserver' in window) {
      var words = { 'Discounts': 'Reducere', 'Discount': 'Reducere' };
      var busy = false;
      var tr = function () {
        if (busy) return; busy = true;
        var w = document.createTreeWalker(form, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) { var t = n.nodeValue.trim(); if (words[t]) n.nodeValue = n.nodeValue.replace(t, words[t]); }
        busy = false;
      };
      new MutationObserver(tr).observe(form, { childList: true, subtree: true, characterData: true });
      tr();
    }
    var bar = document.querySelector('.ba-bar'), hero = document.querySelector('.ba-hero');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var pastHero = false, atForm = false;
    function paint() { bar.classList.toggle('is-on', pastHero && !atForm); }
    new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; paint(); }).observe(hero);
    if (form) new IntersectionObserver(function (en) { atForm = en[0].isIntersecting; paint(); }, { rootMargin: '0px 0px -30% 0px' }).observe(form);
  }
  /* Paginile din carte: banda se deruleaza singura, fara capat (sirul e dublat); o apasare o opreste, inca una o porneste. */
  function pages() {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-ba-pages]'), function (box) {
      var track = box.querySelector('.ba-track');
      if (!track || track.children.length < 2) return;
      var copy = track.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(copy.querySelectorAll('img'), function (i) { i.loading = 'eager'; });
      box.appendChild(copy);
      function speed() { box.style.setProperty('--ba-dur', Math.max(20, Math.round(track.scrollWidth / 45)) + 's'); }
      speed(); window.addEventListener('load', speed); window.addEventListener('resize', speed);
      box.scrollLeft = 0;
      box.classList.add('is-auto');
      var hint = box.parentNode.parentNode.querySelector('[data-ba-hint]');
      box.addEventListener('click', function () {
        var off = box.classList.toggle('is-paused');
        if (hint) hint.textContent = off ? hint.getAttribute('data-stop') : hint.getAttribute('data-run');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
